module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary"
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-success"
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger"
    }
  }, [_vm._v("Danger")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-warning"
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-light"
    }
  }, [_vm._v("Light")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-dark"
    }
  }, [_vm._v("Dark")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-text"
    }
  }, [_vm._v("Text")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "loading": ""
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "rounded": ""
    }
  }, [_vm._v("Rounded")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary",
      "outlined": ""
    }
  }, [_vm._v("Outlined")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-success",
      "outlined": ""
    }
  }, [_vm._v("Outlined")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-danger",
      "outlined": ""
    }
  }, [_vm._v("Outlined")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-warning",
      "outlined": ""
    }
  }, [_vm._v("Outlined")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary",
      "expanded": ""
    }
  }, [_vm._v("Expanded")])], 1), _vm._v(" "), _c('div', {
    staticClass: "notification is-primary"
  }, [_c('b-button', {
    attrs: {
      "type": "is-primary",
      "inverted": ""
    }
  }, [_vm._v("\n                Inverted\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "is-primary",
      "inverted": "",
      "outlined": ""
    }
  }, [_vm._v("\n                Invert Outlined\n            ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6d74a46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/button/examples/ExTypesStates.vue
// module id = 973
// module chunks = 21 238